import { useMemo } from "react";
import ILocation from "../interfaces/ILocation";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (locations: ILocation[], shape: Shape | Shape[] | null): ILocation[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? locations.filter(l => geometryService.isPointInsideShape(l.centerPoint, shape)) : locations, [locations, shape]);
}
